import { mediaQueries } from '@tallink/components-lib/src/constants/media'
import React from 'react'
import { useDispatch } from 'react-redux'
import { useMedia } from 'react-use'

import { addTicket, removeTicket } from '../../../actions/actions'
import MorePropTypes from '../../../utils/MorePropTypes'
import DesktopSerialTicket from './DesktopSerialTicket'
import MobileSerialTicket from './MobileSerialTicket'

export default function SerialTicket({ ticket }) {
  const smUp = useMedia(mediaQueries.smUp)
  const dispatch = useDispatch()
  const desktopProps = {
    ticket,
    plusMinusProps: {
      disabled: false,
      maxValue: ticket.maxCount,
      onDecreaseClick: () => dispatch(removeTicket(ticket)),
      onIncreaseClick: () => dispatch(addTicket(ticket)),
      type: 'classic',
      value: ticket.count
    }
  }
  const mobileProps = {
    ticket,
    plusMinusProps: {
      value: ticket.count,
      decreaseDisabled: ticket.count <= 0,
      increaseDisabled: ticket.count >= ticket.maxCount,
      onDecreaseClick: () => dispatch(removeTicket(ticket)),
      onIncreaseClick: () => dispatch(addTicket(ticket))
    }
  }

  return smUp ? <DesktopSerialTicket {...desktopProps} /> : <MobileSerialTicket {...mobileProps} />
}

SerialTicket.propTypes = {
  ticket: MorePropTypes.serialTicket.isRequired
}
